@if (entryObject) {
<div class="mt-3">
  <div class="card" [ngClass]="{ 'is-customer': incomingMessage }">
    <div class="card-body">
      <h6 class="card-subtitle mb-2 text-muted"><strong>{{ entryObject.senderName !== '' ? entryObject.senderName : entryObject.senderEmail }}</strong><span class="ml-3">{{
          entryObject.createdAt * 1000 | localized_datetime }}</span></h6>
      <div class="mt-3" [innerHTML]="entryObject.text | keepHtml"></div>
    </div>
    <div class="ml-1 mb-2">
      @if (hasAttachment) {
      <hr class="ml-1 mr-2">
      <app-conversation-attachments [attachments]="attachments"
        (onAttachmentClicked)="onAttachmentClick($event)"></app-conversation-attachments>
      }
    </div>
  </div>
</div>
}